export default __webpack_public_path__ + "static/media/09.9e138baa.png";